import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  meterId: "",
  meterHead: "",
  rate9am6pm: "",
  rate6pm10pm: "",
  flatRate: "",
  timeLimit9am6pm: "",
  timeLimit6pm10pm: "",
  timeLimitWeekend9am6pm: "",
  timeLimitWeekend6pm10pm: "",
  creditCard: "",
  payPhone: "",
  informationBox: false
};


export const meterInfoSlice = createSlice({
  name: 'meterInfo',
  initialState,
  reducers: {
    save: (state, action) => {
      state.meterId = action.payload.meterId;
      state.meterHead = action.payload.meterHead;
      state.rate9am6pm = action.payload.rate9am6pm;
      state.rate6pm10pm = action.payload.rate6pm10pm;
      state.flatRate = action.payload.flatRate;
      state.timeLimit9am6pm = action.payload.timeLimit9am6pm;
      state.timeLimit6pm10pm = action.payload.timeLimit6pm10pm;
      state.timeLimitWeekend9am6pm = action.payload.timeLimitWeekend9am6pm;
      state.timeLimitWeekend6pm10pm = action.payload.timeLimitWeekend6pm10pm;
      state.creditCard = action.payload.creditCard;
      state.payPhone = action.payload.payPhone;
    },
    reset: (state, action) => {
      state.meterId = initialState.meterId;
      state.meterHead = initialState.meterHead;
      state.rate9am6pm = initialState.rate9am6pm;
      state.rate6pm10pm = initialState.rate6pm10pm;
      state.flatRate = initialState.flatRate;
      state.timeLimit9am6pm = initialState.timeLimit9am6pm;
      state.timeLimit6pm10pm = initialState.timeLimit6pm10pm;
      state.timeLimitWeekend9am6pm = initialState.timeLimitWeekend9am6pm;
      state.timeLimitWeekend6pm10pm = initialState.timeLimitWeekend6pm10pm;
      state.creditCard = initialState.creditCard;
      state.payPhone = initialState.payPhone;
    },
    setInformationBox: (state, action) => {
      state.informationBox = action.payload;
    }
  }
});

export const meterInfoActions = meterInfoSlice.actions;
export default meterInfoSlice.reducer
